import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl";
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import Patnewcss from "../../public/css/doctor/doctor.css";
import RetailerHeader from "../retailer/RetailerHeader";
import PatientFooter from "../patient/Patientfooter";
import { reactLocalStorage } from "reactjs-localstorage";
import * as XLSX from "xlsx";
import DataTable from "react-data-table-component";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import * as SecureLS from "secure-ls";
import ColumnMappingDialog from "./ColumnMappingDialog";
import ProductMatchPreview from "./ProductMatchPreview";
import RetailerUploadService from "../../services/retailerUploadService";
import { Button, Spinner, Alert, ProgressBar } from "react-bootstrap";
import { normalizeExpiryDate, formatExpiryDateDisplay } from "../../helpers/dateUtils";

var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

// Normally rendered inside the pharmacy portal, where the retailer comes from
// the retailer session. The admin panel reuses this screen for the operations
// role: it passes the chosen pharmacy as retailerId and sets embedded so the
// pharmacy chrome and the pharmacy-only navigation stay out of the way.
function Retaileruploadstock({ retailerId: retailerIdProp, embedded }) {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [showbutton, setbutton] = useState("upload_stock_btn collapse-hide");
  
  // New state for advanced features
  const [showMappingDialog, setShowMappingDialog] = useState(false);
  const [excelHeaders, setExcelHeaders] = useState([]);
  const [excelRawData, setExcelRawData] = useState([]);
  const [savedMapping, setSavedMapping] = useState(null);
  const [mappedProducts, setMappedProducts] = useState([]);
  const [matchedProducts, setMatchedProducts] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [retailerId, setRetailerId] = useState(retailerIdProp || null);
  const [useAdvancedMode, setUseAdvancedMode] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [matchingProgress, setMatchingProgress] = useState(0);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [skippedProductsReport, setSkippedProductsReport] = useState([]);
  const [successfulProductsReport, setSuccessfulProductsReport] = useState([]);
  
  // File input ref
  const fileInputRef = React.useRef(null);
  
  // Store raw Excel data in ref to prevent loss during re-renders
  const excelDataRef = React.useRef({ headers: [], rows: [] });
  
  const excelData = [];
  
  // Required fields for all products - these must be present for a row to be uploaded
  // NOTE: Packaging can be any format: number (10, 15), text ("Strip of 10"), or combination ("1x10")
  const REQUIRED_FIELDS = ['medicinename', 'packaging', 'mrp', 'manufacturer', 'batch', 'quantity', 'expiry', 'vat'];
  
  // Helper to find a field value regardless of case or key name difference
  const findFieldValue = (product, fieldName) => {
    // Direct exact match (lowercase)
    const directValue = product[fieldName];
    if (directValue !== undefined && directValue !== null && String(directValue).trim() !== '') {
      return String(directValue).trim();
    }
    
    // Try capitalized version
    const capitalized = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
    const capValue = product[capitalized];
    if (capValue !== undefined && capValue !== null && String(capValue).trim() !== '') {
      return String(capValue).trim();
    }
    
    // Special handling for product name aliases
    if (fieldName === 'medicinename' || fieldName === 'productname') {
      const aliases = ['productName', 'ProductName', 'MedicineName', 'medicinename', 'productname', 'medicine_name', 'product_name'];
      for (const alias of aliases) {
        const aliasValue = product[alias];
        if (aliasValue !== undefined && aliasValue !== null && String(aliasValue).trim() !== '') {
          return String(aliasValue).trim();
        }
      }
    }
    
    // Special handling for packaging aliases
    if (fieldName === 'packaging') {
      const aliases = ['Packaging', 'packaging', 'packaging_detail', 'packagingDetail', 'Pack', 'pack', 'PackSize', 'pack_size'];
      for (const alias of aliases) {
        const aliasValue = product[alias];
        if (aliasValue !== undefined && aliasValue !== null && String(aliasValue).trim() !== '') {
          return String(aliasValue).trim();
        }
      }
    }
    
    // Try to find any key that matches (case-insensitive)
    const key = Object.keys(product).find(k => 
      k.toLowerCase().replace(/\s+/g, '') === fieldName.toLowerCase().replace(/\s+/g, '')
    );
    if (key) {
      const keyValue = product[key];
      if (keyValue !== undefined && keyValue !== null && String(keyValue).trim() !== '') {
        return String(keyValue).trim();
      }
    }
    
    return null;
  };
  
  // Validate that all required fields are present
  const validateRequiredFields = (product, rowIndex = null) => {
    const missingFields = [];
    const foundValues = {};
    
    // Check product name (medicinename is the primary field after mapping)
    const productName = findFieldValue(product, 'medicinename');
    foundValues.medicinename = productName;
    if (!productName || productName === '') {
      missingFields.push('Medicine Name/Product Name');
    }
    
    // Check packaging - CRITICAL FIELD (accepts any non-empty value: numbers, text, or combinations)
    const packaging = findFieldValue(product, 'packaging');
    foundValues.packaging = packaging;
    if (!packaging || packaging === '') {
      missingFields.push('Packaging (can be number like "10", text like "Strip of 10", or combination like "1x10")');
    }
    
    // Check MRP
    const mrp = findFieldValue(product, 'mrp');
    foundValues.mrp = mrp;
    if (!mrp || mrp === '' || isNaN(parseFloat(mrp))) {
      missingFields.push('MRP (numeric price)');
    }

    // Check Manufacturer
    const manufacturer = findFieldValue(product, 'manufacturer');
    foundValues.manufacturer = manufacturer;
    if (!manufacturer || manufacturer === '') {
      missingFields.push('Manufacturer');
    }

    // Check Batch Number
    const batch = findFieldValue(product, 'batch');
    foundValues.batch = batch;
    if (!batch || batch === '') {
      missingFields.push('Batch Number');
    }

    // Check Quantity
    const quantity = findFieldValue(product, 'quantity');
    foundValues.quantity = quantity;
    if (!quantity || quantity === '') {
      missingFields.push('Quantity');
    }

    // Check Expiry
    const expiry = findFieldValue(product, 'expiry');
    foundValues.expiry = expiry;
    if (!expiry || expiry === '') {
      missingFields.push('Expiry Date');
    }

    // Check VAT/GST
    const vat = findFieldValue(product, 'vat');
    foundValues.vat = vat;
    if (!vat || vat === '') {
      missingFields.push('VAT/GST');
    }
    
    return {
      isValid: missingFields.length === 0,
      missingFields,
      foundValues,
      productName: productName || 'Unknown',
      rowIndex
    };
  };

  // Standard normal mode headers (must match exactly - case insensitive)
  const NORMAL_MODE_HEADERS = [
    'MedicineName',
    'Manufacturer', 
    'Form',
    'Packaging',
    'Quantity',
    'Batch',
    'Expirydate',
    'Discount',
    'MRP',
    'GST',
    'productId'
  ];

  // Detect and skip metadata/title rows in Excel files
  const findActualHeaderRow = (jsonData) => {
    if (!jsonData || jsonData.length === 0) return { headerRowIndex: -1, headers: [], rows: [] };
    
    // Look for the row that has the most non-empty cells and looks like headers
    let bestHeaderIndex = 0;
    let maxNonEmptyCells = 0;
    
    // Check first 20 rows to find headers
    const searchLimit = Math.min(20, jsonData.length);
    
    for (let i = 0; i < searchLimit; i++) {
      const row = jsonData[i];
      if (!row || row.length === 0) continue;
      
      // Count non-empty cells
      const nonEmptyCells = row.filter(cell => 
        cell !== null && cell !== undefined && String(cell).trim() !== ''
      ).length;
      
      // Check if row looks like headers (has strings, not just numbers/dates)
      const stringCells = row.filter(cell => {
        if (!cell) return false;
        const str = String(cell).trim();
        // Headers typically have: letters, underscores, or common header words
        return /[a-zA-Z_]/.test(str) && str.length > 1;
      }).length;
      
      // A good header row should have:
      // 1. Many non-empty cells (at least 3)
      // 2. Mostly string values (at least 80% of non-empty cells)
      // 3. Common header patterns (product, name, price, mrp, batch, etc.)
      const hasCommonHeaderWords = row.some(cell => {
        if (!cell) return false;
        const str = String(cell).toLowerCase();
        return str.includes('product') || str.includes('name') || str.includes('mrp') ||
               str.includes('price') || str.includes('batch') || str.includes('qty') ||
               str.includes('quantity') || str.includes('pack') || str.includes('expiry');
      });
      
      const isLikelyHeader = nonEmptyCells >= 3 && 
                            stringCells >= Math.max(3, nonEmptyCells * 0.6) &&
                            nonEmptyCells > maxNonEmptyCells;
      
      if (isLikelyHeader || hasCommonHeaderWords) {
        maxNonEmptyCells = nonEmptyCells;
        bestHeaderIndex = i;
        
        if (hasCommonHeaderWords) {
          // If we found common header words, this is very likely the header row
          console.log(`[HEADER-DETECT] Found likely header row at index ${i} with common header terms`);
          break;
        }
      }
    }
    
    const headers = jsonData[bestHeaderIndex];
    const rows = jsonData.slice(bestHeaderIndex + 1).filter(row => {
      // Filter out completely empty rows
      if (!row || row.length === 0) return false;
      
      // Count non-empty cells
      const nonEmptyCells = row.filter(cell => 
        cell !== null && cell !== undefined && String(cell).trim() !== ''
      ).length;
      
      // Row must have at least 2 non-empty cells to be considered valid data
      // This filters out rows with just one random value
      return nonEmptyCells >= 2;
    });
    
    console.log(`[HEADER-DETECT] Selected header row index: ${bestHeaderIndex}`);
    console.log(`[HEADER-DETECT] Headers found:`, headers);
    console.log(`[HEADER-DETECT] Data rows after headers: ${rows.length}`);
    console.log(`[HEADER-DETECT] First data row columns: ${rows[0]?.length || 0}`);
    console.log(`[HEADER-DETECT] First data row sample:`, rows[0]?.slice(0, 5));
    console.log(`[HEADER-DETECT] Skipped ${bestHeaderIndex} metadata/title rows`);
    
    // CRITICAL VALIDATION: Verify data rows have similar column count as headers
    if (rows.length > 0) {
      const headerColumnCount = headers.filter(h => h !== null && h !== undefined && String(h).trim() !== '').length;
      const firstDataColumnCount = rows[0].filter(c => c !== null && c !== undefined && String(c).trim() !== '').length;
      
      console.log(`[HEADER-DETECT] Validation: Headers have ${headerColumnCount} columns, first data row has ${firstDataColumnCount} columns`);
      
      // If data row has significantly fewer columns than headers, we detected wrong row
      if (firstDataColumnCount < headerColumnCount * 0.3) {
        console.warn(`[HEADER-DETECT] ⚠️ WARNING: Header/Data column mismatch! Searching for better header row...`);
        
        // Try to find a better header row by looking for rows where data also has many columns
        for (let i = bestHeaderIndex + 1; i < Math.min(bestHeaderIndex + 10, jsonData.length); i++) {
          const testRow = jsonData[i];
          if (!testRow) continue;
          
          const testColumns = testRow.filter(c => c !== null && c !== undefined && String(c).trim() !== '').length;
          if (testColumns >= headerColumnCount * 0.5) {
            // Found a row with enough columns - use the previous row as headers
            console.log(`[HEADER-DETECT] ✓ Found data row ${i} with ${testColumns} columns. Using row ${i-1} as headers.`);
            const newHeaderIndex = i - 1;
            const newHeaders = jsonData[newHeaderIndex];
            const newRows = jsonData.slice(i).filter(row => {
              // Filter out completely empty rows
              if (!row || row.length === 0) return false;
              
              // Count non-empty cells
              const nonEmptyCells = row.filter(cell => 
                cell !== null && cell !== undefined && String(cell).trim() !== ''
              ).length;
              
              // Row must have at least 2 non-empty cells to be considered valid data
              return nonEmptyCells >= 2;
            });
            
            console.log(`[HEADER-DETECT] Corrected: Header row ${newHeaderIndex}, ${newRows.length} data rows`);
            console.log(`[HEADER-DETECT] Corrected headers:`, newHeaders);
            console.log(`[HEADER-DETECT] Corrected first data row:`, newRows[0]?.slice(0, 5));
            
            return { headerRowIndex: newHeaderIndex, headers: newHeaders, rows: newRows };
          }
        }
        
        // Could not find valid structure - return error
        console.error(`[HEADER-DETECT] ❌ FAILED: Could not identify valid header row and data structure.`);
        console.error(`[HEADER-DETECT] ❌ Headers detected at row ${bestHeaderIndex} have ${headerColumnCount} columns`);
        console.error(`[HEADER-DETECT] ❌ First data row has only ${firstDataColumnCount} columns`);
        console.error(`[HEADER-DETECT] ❌ Please ensure your Excel file has consistent column structure.`);
        
        // Return error - will trigger "Could not find valid headers" toast
        return { 
          headerRowIndex: -1, 
          headers: [], 
          rows: [],
          error: `Excel structure mismatch: Headers have ${headerColumnCount} columns but data rows have ${firstDataColumnCount} columns. Please ensure your Excel file has headers in one row followed by data with matching columns.`
        };
      }
    }
    
    return { headerRowIndex: bestHeaderIndex, headers, rows };
  };

  // Check if Excel headers match normal mode format
  // NOTE: Excel headers can be ANYTHING - this just checks if they match standard format
  // If not, user will be prompted to MAP their columns in the dialog (which is mandatory)
  const detectUploadMode = (headers) => {
    if (!headers || headers.length === 0) return false;
    
    // Normalize headers for comparison (trim and lowercase)
    const normalizedHeaders = headers.map(h => String(h).trim().toLowerCase());
    const normalizedStandard = NORMAL_MODE_HEADERS.map(h => h.toLowerCase());
    
    // Check if all standard headers are present
    const allHeadersMatch = normalizedStandard.every(standardHeader => 
      normalizedHeaders.includes(standardHeader)
    );
    
    console.log('[AUTO-DETECT] Headers match check:', {
      excelHeaders: headers,
      standardHeaders: NORMAL_MODE_HEADERS,
      allMatch: allHeadersMatch
    });
    
    return allHeadersMatch;
  };

  // Initialize on component mount, and again whenever the caller switches the
  // pharmacy (the admin Stock Upload screen does this from its dropdown).
  React.useEffect(() => {
    if (retailerIdProp) {
      setRetailerId(retailerIdProp);
      loadSavedMapping(retailerIdProp);
      return;
    }
    const userData = ls.get("retuserObj");
    if (userData && userData.retailer_id) {
      setRetailerId(userData.retailer_id);
      loadSavedMapping(userData.retailer_id);
    }
  }, [retailerIdProp]);

  // Load saved column mapping
  const loadSavedMapping = async (retailerId) => {
    try {
      const response = await RetailerUploadService.getColumnMapping(retailerId);
      if (response.data && !response.data.error && response.data.data) {
        setSavedMapping(response.data.data);
        toast.info('Saved column mapping loaded');
      }
    } catch (error) {
      console.error('Error loading saved mapping:', error);
    }
  };

  // process CSV data
  const processData = (dataString) => {
    const dataStringLines = dataString.split(/\r\n|\n/);
    const headers = dataStringLines[0].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
    );

    const list = [];
    for (let i = 1; i < dataStringLines.length; i++) {
      const row = dataStringLines[i].split(
        /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
      );
      if (headers && row.length == headers.length) {
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          let d = row[j];
          if (d.length > 0) {
            if (d[0] == '"') d = d.substring(1, d.length - 1);
            if (d[d.length - 1] == '"') d = d.substring(d.length - 2, 1);
          }
          
          // Normalize expiry date fields
          if (headers[j]) {
            const headerLower = headers[j].toLowerCase().trim();
            if (headerLower.includes('expiry') || headerLower.includes('expire')) {
              const normalizedDate = normalizeExpiryDate(d);
              if (normalizedDate) {
                d = normalizedDate;
              }
            }
            obj[headers[j]] = d;
          }
        }

        if (Object.values(obj).filter((x) => x).length > 0) {
          list.push(obj);
        }
      }
    }

    // prepare columns list from headers
    const columns = headers.map((c) => ({
      name: c,
      selector: c,
    }));
    if (list.length > 0) {
      setbutton("upload_stock_btn collapse-show");
    }
    setData(list);
    setColumns(columns);
  };

  // handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    
    if (!file) {
      toast.error('Please select a file');
      return;
    }
    
    // Clear previous data
    setExcelHeaders([]);
    setExcelRawData([]);
    setMatchedProducts([]);
    setMappedProducts([]);
    setShowPreview(false);
    setShowMappingDialog(false);
    setData([]);
    setColumns([]);
    setSelectedFileName(file.name);
    
    console.log(`[FRONTEND] File selected: ${file.name} (${(file.size / 1024).toFixed(2)} KB)`);
    
    const reader = new FileReader();
    
    // Read file to detect mode
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1 });

      if (jsonData.length > 0) {
        // Smart header detection - skip metadata/title rows
        const { headerRowIndex, headers, rows, error } = findActualHeaderRow(jsonData);
        
        if (headerRowIndex === -1 || !headers || headers.length === 0) {
          const errorMessage = error || 'Could not find valid headers in Excel file';
          toast.error(errorMessage, { autoClose: 8000 });
          console.error('[FRONTEND] Header detection failed:', errorMessage);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          setSelectedFileName('');
          return;
        }
        
        if (rows.length === 0) {
          toast.error('Excel file has no data rows after headers');
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          setSelectedFileName('');
          return;
        }
        
        if (headerRowIndex > 0) {
          toast.info(`Detected and skipped ${headerRowIndex} metadata rows. Found headers at row ${headerRowIndex + 1}.`, { 
            autoClose: 4000 
          });
        }
        
        // ✅ CRITICAL: Store in ref IMMEDIATELY before any other operations
        // This ensures data is never lost even if state updates fail
        excelDataRef.current = { headers, rows };
        console.log(`[FRONTEND] ✓ Data stored in ref: ${headers.length} columns, ${rows.length} rows`);
        
        console.log(`[FRONTEND] Excel loaded: ${headers.length} columns, ${rows.length} rows`);
        console.log(`[FRONTEND] Excel headers:`, headers);
        
        // AUTO-DETECT MODE based on headers
        const isNormalMode = detectUploadMode(headers);
        
        if (isNormalMode) {
          // NORMAL MODE - Standard headers detected
          console.log('[AUTO-DETECT] ✓ Normal mode activated - standard headers detected');
          toast.info(`Standard format detected. Please verify column mapping.`, { autoClose: 3000 });
          setUseAdvancedMode(false);
          
          // Directly create data structure from headers and rows (more reliable than CSV conversion)
          const list = [];
          rows.forEach((row, rowIndex) => {
            const obj = {};
            headers.forEach((header, colIndex) => {
              let value = row[colIndex] || '';
              
              // Normalize expiry date fields regardless of header name
              const headerLower = header.toLowerCase().trim();
              if (headerLower.includes('expiry') || headerLower.includes('expire')) {
                const normalizedDate = normalizeExpiryDate(value);
                if (normalizedDate) {
                  value = normalizedDate;
                  console.log(`[NORMAL-MODE-DATE] Normalized expiry: "${row[colIndex]}" -> "${value}"`);
                }
              }
              
              obj[header] = value;
            });
            
            // Only add if row has at least one non-empty value
            if (Object.values(obj).filter((x) => x && String(x).trim().length > 0).length > 0) {
              list.push(obj);
            }
          });
          
          console.log(`[FRONTEND] Processed ${list.length} valid rows in Normal Mode`);
          console.log(`[FRONTEND] Sample row:`, list[0]);
          
          // Set data directly
          const columns = headers.map((c) => ({
            name: c,
            selector: c,
          }));
          
          if (list.length > 0) {
            setbutton("upload_stock_btn collapse-show");
          }
          setData(list);
          setColumns(columns);
          
          // ALWAYS SHOW MAPPING DIALOG FOR VERIFICATION (even in normal mode)
          // Store headers and data BEFORE opening dialog
          setExcelHeaders(headers);
          setExcelRawData(rows);
          excelDataRef.current = { headers, rows };
          
          setTimeout(() => {
            // Don't pass default mapping - let auto-mapping detect actual headers
            // The ColumnMappingDialog will auto-map based on actual Excel headers
            console.log('[NORMAL-MODE] Opening dialog for column mapping verification');
            console.log('[NORMAL-MODE] Excel headers:', headers);
            
            // Force show dialog for verification - auto-mapping will run in dialog
            setShowMappingDialog(true);
            console.log('[NORMAL-MODE] Showing mapping dialog - auto-mapping will detect columns');
          }, 150);
          
        } else {
          // ADVANCED MODE - Non-standard headers, need mapping
          console.log('[AUTO-DETECT] ⚠ Advanced mode activated - custom headers detected');
          toast.info(`Custom format detected. Please map your columns.`, { autoClose: 4000 });
          setUseAdvancedMode(true);
          
          // Store in both state and ref for persistence
          setExcelHeaders(headers);
          setExcelRawData(rows);
          excelDataRef.current = { headers, rows };
          
          // ALWAYS REQUIRE MAPPING - Show dialog immediately
          setTimeout(() => {
            setShowMappingDialog(true);
            console.log('[ADVANCED-MODE] Showing mapping dialog for column mapping');
          }, 100);
        }
      } else {
        toast.error('Excel file is empty');
      }
    };
    
    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      toast.error('Error reading file. Please try again.');
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setSelectedFileName('');
    };
    
    reader.readAsBinaryString(file);
  };

  // Handle column mapping save
  const handleSaveMapping = async (mapping, skipSave = false) => {
    try {
      console.log('[FRONTEND] ========= SAVE MAPPING DEBUG =========');
      console.log('[FRONTEND] handleSaveMapping called with mapping:', mapping);
      console.log('[FRONTEND] Mapping details:', { 
        mappingKeys: Object.keys(mapping), 
        mappingValues: Object.values(mapping),
        fullMapping: JSON.stringify(mapping, null, 2),
        skipSave,
        hasExcelData: excelRawData?.length > 0,
        hasHeaders: excelHeaders?.length > 0,
        excelHeadersSample: excelHeaders?.slice(0, 5)
      });
      console.log('[FRONTEND] ========= SAVE MAPPING DEBUG END =========');
      
      setIsLoading(true);
      setMatchingProgress(0);

      // Only save mapping if it's new or changed
      if (!skipSave) {
        setLoadingMessage('Saving column mapping...');
        setMatchingProgress(5);
        const mappingChanged = JSON.stringify(savedMapping) !== JSON.stringify(mapping);
        
        if (mappingChanged) {
          await RetailerUploadService.saveColumnMapping(retailerId, mapping);
          setSavedMapping(mapping);
          setMatchingProgress(10);
        } else {
          console.log('Mapping unchanged, skipping save');
          setMatchingProgress(10);
        }
      }
      
      // Apply mapping and match products (main operation)
      setLoadingMessage('Matching products to master database...');
      await applyMappingAndMatch(mapping);
      
      if (!skipSave) {
        toast.success('Column mapping saved successfully');
      }
    } catch (error) {
      console.error('Error saving mapping:', error);
      toast.error('Error saving column mapping');
    } finally {
      setIsLoading(false);
      setLoadingMessage('');
      setMatchingProgress(0);
    }
  };

  // Apply mapping to Excel data and match products
  const applyMappingAndMatch = async (mapping) => {
    try {
      console.log('[APPLY-MAP] ========== START: applyMappingAndMatch ==========');
      console.log('[APPLY-MAP] Received mapping object:', mapping);
      console.log('[APPLY-MAP] Mapping keys:', Object.keys(mapping));
      console.log('[APPLY-MAP] Required field values:', {
        medicinename: mapping.medicinename,
        packaging: mapping.packaging,
        mrp: mapping.mrp
      });
      
      // CRITICAL: Validate that required fields are mapped
      const missingMappings = [];
      if (!mapping.medicinename || mapping.medicinename === '') {
        missingMappings.push('Medicine Name (Product Name)');
      }
      if (!mapping.packaging || mapping.packaging === '') {
        missingMappings.push('Packaging (any format: "10", "Strip of 10", "1x10", etc.)');
      }
      if (!mapping.mrp || mapping.mrp === '') {
        missingMappings.push('MRP (Maximum Retail Price)');
      }
      
      if (missingMappings.length > 0) {
        const errorMsg = `❌ CRITICAL ERROR: Required fields not mapped!\n\n` +
          `You must map these fields in the Column Mapping Dialog:\n` +
          `${missingMappings.map(f => `• ${f}`).join('\n')}\n\n` +
          `⚠️ IMPORTANT NOTES:\n` +
          `• "Packaging" accepts any format: numbers ("10"), text ("Strip of 10"), or combinations ("1x10")\n` +
          `• "MRP" should be numeric price (e.g., 124.50), not text\n` +
          `• "Medicine Name" is the product name from your Excel\n\n` +
          `Please close this dialog and map ALL required fields to your Excel columns.\n\n` +
          `📖 Need help? See EXCEL_UPLOAD_REQUIREMENTS.md for detailed guide.`;
        console.error('[APPLY-MAP] ERROR: Missing required field mappings:', missingMappings);
        console.error('[APPLY-MAP] Full mapping received:', mapping);
        toast.error(errorMsg, { autoClose: 15000 });
        setIsLoading(false);
        setShowMappingDialog(true); // Re-open dialog
        return;
      }
      
      // CRITICAL: Use ref as primary source since it's more reliable than state
      // State might be lost during re-renders, but ref persists
      const headers = excelDataRef.current?.headers?.length > 0 
        ? excelDataRef.current.headers 
        : excelHeaders;
      const rows = excelDataRef.current?.rows?.length > 0 
        ? excelDataRef.current.rows 
        : excelRawData;
      
      console.log('[DATA-CHECK] Data source verification:', {
        refHeaders: excelDataRef.current?.headers?.length || 0,
        refRows: excelDataRef.current?.rows?.length || 0,
        stateHeaders: excelHeaders?.length || 0,
        stateRows: excelRawData?.length || 0,
        usingRef: (excelDataRef.current?.headers?.length > 0),
        selectedFile: selectedFileName
      });
      
      console.log('[DATA-CHECK] Actual header values:', headers);
      console.log('[DATA-CHECK] First data row sample:', rows && rows.length > 0 ? rows[0] : 'NO DATA');
      
      // Validate that we have data
      if (!rows || rows.length === 0) {
        console.error('[FRONTEND] ❌ No Excel data available', {
          excelRawDataLength: excelRawData?.length,
          refRowsLength: excelDataRef.current?.rows?.length,
          selectedFileName,
          timestamp: new Date().toISOString()
        });
        toast.error('No Excel data to process. Please upload a file first.');
        setShowMappingDialog(false);
        return;
      }
      
      if (!headers || headers.length === 0) {
        console.error('[FRONTEND] ❌ No Excel headers available', {
          excelHeadersLength: excelHeaders?.length,
          refHeadersLength: excelDataRef.current?.headers?.length,
          selectedFileName,
          timestamp: new Date().toISOString()
        });
        toast.error('Excel headers not found. Please try uploading again.');
        setShowMappingDialog(false);
        return;
      }
      
      console.log(`[FRONTEND] ✓ Data verified: ${headers.length} columns, ${rows.length} rows`);
      
      // Don't set loading here - parent function handles it
      const mapStart = Date.now();
      console.log(`[FRONTEND] Starting mapping for ${rows.length} rows`);
      console.log(`[FRONTEND] Excel headers:`, headers);
      console.log(`[FRONTEND] Column mapping:`, mapping);
      setLoadingMessage(`Mapping ${rows.length} products...`);
      setMatchingProgress(15);

      // Helper function to find column index (case-insensitive, trim whitespace)
      const findColumnIndex = (headers, columnName) => {
        if (!columnName) return -1;
        
        // Try exact match first
        let index = headers.indexOf(columnName);
        if (index >= 0) return index;
        
        // Try case-insensitive and trimmed match
        const normalizedSearch = String(columnName).toLowerCase().trim();
        index = headers.findIndex(h => 
          String(h).toLowerCase().trim() === normalizedSearch
        );
        
        if (index >= 0) {
          console.log(`[COLUMN-MATCH] Fuzzy match: "${columnName}" matched to "${headers[index]}" at index ${index}`);
        }
        
        return index;
      };

      // Transform Excel data using mapping with progress updates
      const mapped = [];
      const totalRows = rows.length;
      const chunkSize = Math.max(1, Math.floor(totalRows / 10)); // Update progress 10 times
      const validationErrors = [];
      
      // Debug: Log first row raw data and mapping
      if (rows.length > 0) {
        console.log('[DEBUG] ========= MAPPING DEBUG START =========');
        console.log('[DEBUG] First Excel row (raw):', rows[0]);
        console.log('[DEBUG] Excel headers:', headers);
        console.log('[DEBUG] Column mapping received:', mapping);
        console.log('[DEBUG] Number of fields mapped:', Object.keys(mapping).length);
        
        // Check if mapping has required fields with improved column finding
        const requiredMapped = ['medicinename', 'packaging', 'mrp'].map(field => {
          const excelColumn = mapping[field];
          const headerIndex = findColumnIndex(headers, excelColumn);
          return {
            field,
            excelColumn,
            headerIndex,
            found: headerIndex >= 0,
            sampleValue: headerIndex >= 0 ? rows[0][headerIndex] : 'N/A'
          };
        });
        console.log('[DEBUG] Required field mapping status:', requiredMapped);
        console.log('[DEBUG] ========= MAPPING DEBUG END =========');
      }
      
      rows.forEach((row, index) => {
        const product = {};
        
        // Apply mapping: internalField <- excelColumn value
        Object.keys(mapping).forEach(internalField => {
          const excelColumn = mapping[internalField];
          const columnIndex = findColumnIndex(headers, excelColumn);
          
          if (index === 0) {
            // Debug first row mapping in detail
            console.log(`[MAP-DETAIL] Field="${internalField}" -> Excel="${excelColumn}" at index ${columnIndex}, value="${row[columnIndex]}"`);
          }
          
          if (columnIndex >= 0 && columnIndex < row.length) {
            const cellValue = row[columnIndex];
            // Normalize value: convert to string, trim, handle null/undefined
            if (cellValue !== undefined && cellValue !== null && String(cellValue).trim() !== '') {
              let normalizedValue = String(cellValue).trim();
              
              // SPECIAL HANDLING: Normalize expiry dates to MM/YYYY format
              if (internalField === 'expiry' || internalField === 'expiryDate' || internalField === 'expiry_date') {
                const normalizedDate = normalizeExpiryDate(cellValue);
                if (normalizedDate) {
                  normalizedValue = normalizedDate;
                  if (index === 0) {
                    console.log(`[DATE-NORMALIZE] Expiry date: "${cellValue}" -> "${normalizedValue}"`);
                  }
                } else if (index === 0) {
                  console.warn(`[DATE-NORMALIZE] Could not normalize expiry date: "${cellValue}"`);
                }
              }
              
              product[internalField] = normalizedValue;
            } else {
              product[internalField] = ''; // Empty string for missing values
            }
          } else {
            product[internalField] = ''; // Column not found or out of bounds
            if (index === 0) {
              console.error(`[MAP-ERROR] Column "${excelColumn}" not found in headers for field "${internalField}"`);
              console.error(`[MAP-ERROR] Available headers:`, headers);
            }
          }
        });
        
        // CRITICAL: Skip rows where ALL required fields are empty (garbage/partial rows)
        const hasAnyRequiredField = 
          (product.medicinename && product.medicinename.trim() !== '') ||
          (product.packaging && product.packaging.trim() !== '') ||
          (product.mrp && product.mrp.trim() !== '');
        
        if (!hasAnyRequiredField) {
          console.log(`[ROW-SKIP] Skipping row ${index + 1} - all required fields are empty:`, row.slice(0, 5));
          return; // Skip this row completely
        }
        
        // CRITICAL: Ensure medicinename field exists
        // If mapping used 'productName', copy to 'medicinename' for consistency
        if (product.productName && !product.medicinename) {
          product.medicinename = product.productName;
        }
        if (product.MedicineName && !product.medicinename) {
          product.medicinename = product.MedicineName;
        }
        
        // CRITICAL: Normalize expiry field names for consistency
        // Ensure we have 'expiry' field regardless of what the Excel column was called
        if (!product.expiry) {
          product.expiry = product.expiryDate || product.expiry_date || product.Expirydate || product.ExpiryDate || '';
        }
        
        // Debug first few products
        if (index < 3) {
          console.log(`[DEBUG] Row ${index + 1} mapped:`, {
            rawRow: row,
            mappedProduct: product,
            medicinename: product.medicinename,
            packaging: product.packaging,
            mrp: product.mrp
          });
        }
        
        // Validate required fields including Packaging
        const validation = validateRequiredFields(product, index + 2);
        if (!validation.isValid) {
          validationErrors.push({
            rowNumber: index + 2,
            productName: validation.productName,
            missingFields: validation.missingFields,
            foundValues: validation.foundValues,
            excelRow: row.slice(0, 5) // First 5 cells for debugging
          });
          
          // Debug validation errors
          if (validationErrors.length <= 3) {
            console.error(`[VALIDATION ERROR] Row ${index + 2}:`, {
              product,
              validation,
              mapping,
              rawRow: row
            });
          }
        }
        
        mapped.push(product);
        
        // Update progress every chunk
        if (index % chunkSize === 0 || index === totalRows - 1) {
          const progress = 15 + Math.floor((index / totalRows) * 15); // 15-30%
          setMatchingProgress(progress);
          setLoadingMessage(`Mapped ${index + 1} of ${totalRows} products...`);
        }
      });

      const mapEnd = Date.now();
      console.log(`[FRONTEND] Mapped ${mapped.length} products in ${mapEnd - mapStart}ms`);
      console.log(`[FRONTEND] Skipped ${totalRows - mapped.length} empty/partial rows (had all required fields empty)`);
      
      // COMPREHENSIVE MAPPING SUMMARY
      console.log('[MAPPING-SUMMARY] ========================================');
      console.log('[MAPPING-SUMMARY] Total rows in Excel:', totalRows);
      console.log('[MAPPING-SUMMARY] Rows skipped (empty/partial):', totalRows - mapped.length);
      console.log('[MAPPING-SUMMARY] Products mapped:', mapped.length);
      console.log('[MAPPING-SUMMARY] Validation errors:', validationErrors.length);
      console.log('[MAPPING-SUMMARY] Mapping configuration:', mapping);
      console.log('[MAPPING-SUMMARY] Sample successfully mapped products (first 3):');
      mapped.slice(0, 3).forEach((p, i) => {
        console.log(`  [${i + 1}] medicinename="${p.medicinename}", packaging="${p.packaging}", mrp="${p.mrp}"`);
      });
      if (validationErrors.length > 0) {
        console.log('[MAPPING-SUMMARY] Sample failed products (first 3):');
        validationErrors.slice(0, 3).forEach((e, i) => {
          console.log(`  [${i + 1}] Row ${e.rowNumber}:`, e.foundValues);
        });
      }
      console.log('[MAPPING-SUMMARY] ========================================');
      
      // CONTINUE UPLOADING: Even if there are validation errors, upload valid products
      // Separate products into valid (passed validation) and invalid (missing values)
      const validProducts = [];
      const skippedProductsReport = [];
      
      mapped.forEach((product, index) => {
        // Find corresponding validation error for this product
        const validationError = validationErrors.find(e => e.rowNumber === index + 2);
        
        if (!validationError) {
          // This product passed validation - include in upload
          validProducts.push(product);
        } else {
          // This product failed validation - add to skip report
          skippedProductsReport.push({
            rowNumber: validationError.rowNumber,
            productData: product,
            reason: `Missing: ${validationError.missingFields.join(', ')}`
          });
        }
      });
      
      console.log('[VALIDATION-SPLIT] Valid products:', validProducts.length);
      console.log('[VALIDATION-SPLIT] Skipped products:', skippedProductsReport.length);
      console.log('[VALIDATION-SPLIT] ========================================');
      
      // Save to state for export later
      setSuccessfulProductsReport(validProducts);
      setSkippedProductsReport(skippedProductsReport);
      
      // Check for validation errors - but DON'T BLOCK, continue with valid products
      if (validationErrors.length > 0) {
        console.warn('[VALIDATION] Some rows have missing values, continuing with valid products');
        console.warn('[VALIDATION] Skipped products count:', skippedProductsReport.length);
        
        // Show warning toast - continue with valid products
        const errorSummary = validationErrors.slice(0, 3).map(e => {
          return `   • Row ${e.rowNumber} (${e.productName}): Missing: ${e.missingFields.join(', ')}`;
        }).join('\n');
        
        const moreErrors = validationErrors.length > 3 ? `\n... and ${validationErrors.length - 3} more rows with missing values` : '';
        
        toast.warning(
          `⚠️ ${validationErrors.length} rows have missing mandatory values and were exported for review. Uploading ${validProducts.length} valid products...`,
          { autoClose: 8000 }
        );
      }
      
      // If NO valid products, stop here
      if (validProducts.length === 0) {
        console.error('[VALIDATION] No valid products to upload after validation');
        toast.error('❌ No valid products found. All rows are missing mandatory values. Please check your Excel file.');
        setIsLoading(false);
        return;
      }

      setMappedProducts(validProducts);
      setMatchingProgress(30);

      const totalProducts = validProducts.length;
      const BATCH_THRESHOLD = 1000; // Only use batch processing for datasets > 1000
      const BATCH_SIZE = 500; // Process 500 products per batch
      const BATCH_CONCURRENCY = 4; // Batches kept in flight at once
      
      let response;
      const apiStart = Date.now();
      
      // SMART PROCESSING: Use batch processing only for large datasets
      if (totalProducts > BATCH_THRESHOLD) {
        // BATCH PROCESSING for large datasets
        console.log(`[PROCESSING] Large dataset detected (${totalProducts} products). Using batch processing...`);
        
        const batches = [];
        for (let i = 0; i < totalProducts; i += BATCH_SIZE) {
          batches.push(validProducts.slice(i, i + BATCH_SIZE));
        }
        
        const totalBatches = batches.length;
        const estimatedMinutes = Math.max(1, Math.ceil((totalBatches * 0.5) / BATCH_CONCURRENCY)); // ~30s per batch, BATCH_CONCURRENCY at a time
        
        console.log(`[BATCH-PROCESSING] Splitting ${totalProducts} products into ${totalBatches} batches of ${BATCH_SIZE} each, ${BATCH_CONCURRENCY} in flight`);
        toast.info(`📦 Processing ${totalProducts} products in ${totalBatches} batches. Estimated time: ${estimatedMinutes}-${estimatedMinutes + 1} minutes`, { autoClose: 6000 });
        
        // Batches go out several at a time. Sent one after another the server
        // sat on a single database connection per upload, so a 10k file spent
        // most of its time waiting on round trips rather than on matching.
        const resultsByBatch = new Array(totalBatches);
        const batchErrors = [];
        let batchesDone = 0;
        let nextBatchIndex = 0;

        const runBatch = async (batchIndex) => {
          const currentBatch = batches[batchIndex];
          const batchNumber = batchIndex + 1;
          const batchStart = batchIndex * BATCH_SIZE + 1;
          const batchEnd = Math.min((batchIndex + 1) * BATCH_SIZE, totalProducts);

          try {
            console.log(`[BATCH ${batchNumber}/${totalBatches}] Processing products ${batchStart}-${batchEnd}...`);

            const batchStartTime = Date.now();
            const batchResponse = await RetailerUploadService.validateAndMatchProducts(currentBatch, false);
            console.log(`[BATCH ${batchNumber}/${totalBatches}] Completed in ${Date.now() - batchStartTime}ms`);

            if (batchResponse.data && !batchResponse.data.error) {
              resultsByBatch[batchIndex] = batchResponse.data.data;
              console.log(`[BATCH ${batchNumber}/${totalBatches}] ✓ ${batchResponse.data.data.length} products matched.`);
            } else {
              console.error(`[BATCH ${batchNumber}/${totalBatches}] ❌ Error in response:`, batchResponse.data);
              batchErrors.push({ batch: batchNumber, error: 'Invalid response from server' });
            }
          } catch (error) {
            console.error(`[BATCH ${batchNumber}/${totalBatches}] ❌ Error:`, error);
            batchErrors.push({
              batch: batchNumber,
              error: error.message,
              products: `${batchStart}-${batchEnd}`,
              statusCode: error.response?.status
            });
            toast.warning(`⚠️ Batch ${batchNumber} failed. Continuing...`, { autoClose: 4000 });
          }

          // Batches finish out of order, so report how many are done rather
          // than which one is in flight.
          batchesDone += 1;
          setLoadingMessage(`Processing batch ${batchesDone} of ${totalBatches} (${Math.min(batchesDone * BATCH_SIZE, totalProducts)} of ${totalProducts} products)...`);
          setMatchingProgress(35 + Math.floor((batchesDone / totalBatches) * 50));
        };

        const worker = async () => {
          while (nextBatchIndex < totalBatches) {
            const batchIndex = nextBatchIndex;
            nextBatchIndex += 1;
            await runBatch(batchIndex);
          }
        };

        await Promise.all(
          Array.from({ length: Math.min(BATCH_CONCURRENCY, totalBatches) }, worker)
        );

        // Rebuilt in batch order so the review table matches the Excel order.
        const allMatchedResults = [].concat(
          ...resultsByBatch.map(batchResult => batchResult || [])
        );

        const apiEnd = Date.now();
        const totalTime = apiEnd - apiStart;
        console.log(`[BATCH-PROCESSING] Completed in ${totalTime}ms (${(totalTime/1000).toFixed(1)}s)`);
        console.log(`[BATCH-PROCESSING] Successfully processed: ${allMatchedResults.length} of ${totalProducts} products`);
        
        if (batchErrors.length > 0) {
          console.error(`[BATCH-PROCESSING] Errors in ${batchErrors.length} batches:`, batchErrors);
          toast.error(`⚠️ ${batchErrors.length} batches had errors. Successfully processed ${allMatchedResults.length} products.`, { autoClose: 6000 });
        }
        
        if (allMatchedResults.length === 0) {
          throw new Error('No products were successfully matched. Please check backend server logs.');
        }
        
        // Create combined response
        response = {
          data: {
            data: allMatchedResults,
            timing: {
              totalTime: `${(totalTime/1000).toFixed(2)}s`,
              batches: totalBatches,
              avgBatchTime: `${(totalTime/totalBatches/1000).toFixed(2)}s`
            }
          }
        };
        
      } else {
        // SINGLE API CALL for small datasets (faster, less overhead)
        console.log(`[PROCESSING] Small dataset (${totalProducts} products). Using single API call...`);
        setLoadingMessage(`Matching ${totalProducts} products to master database...`);
        setMatchingProgress(35);
        
        response = await RetailerUploadService.validateAndMatchProducts(validProducts, false);
        
        const apiEnd = Date.now();
        console.log(`[API] Completed in ${apiEnd - apiStart}ms`);
      }
      
      setMatchingProgress(85);

      if (response.data && !response.data.error) {
        const transformStart = Date.now();
        setLoadingMessage('Processing matched results...');
        setMatchingProgress(90);
        
        // Log backend timing if available
        if (response.data.timing) {
          console.log('[BACKEND TIMING]:', response.data.timing);
        }
        
        // DEBUG: Log first item from backend to see structure
        if (response.data.data && response.data.data.length > 0) {
          console.log('[BACKEND-RESPONSE] First item structure:', {
            matchType: response.data.data[0].matchType,
            confidence: response.data.data[0].confidence,
            originalDataKeys: Object.keys(response.data.data[0].originalData || {}),
            originalDataSample: response.data.data[0].originalData,
            matchedProduct: response.data.data[0].matchedProduct?.medicinename
          });
        }
        
        // Transform API response to match component's expected structure
        const transformedData = response.data.data.map(item => {
          // CRITICAL: Exact matches should have NO alternatives field at all
          const isExactMatch = item.matchType === 'exact' || item.confidence === 100;
          
          const matchResult = {
            matchType: item.matchType,
            confidence: item.confidence,
            product: item.matchedProduct,
            message: item.message
          };
          
          // Only add alternatives for non-exact matches
          if (!isExactMatch && item.alternatives && Array.isArray(item.alternatives)) {
            // Prefer alternatives where packaging matches the original upload packaging
            const originalPackaging = (item.originalData && (item.originalData.packaging || item.originalData.packaging_detail)) ? String(item.originalData.packaging || item.originalData.packaging_detail).toLowerCase() : '';
            let alts = item.alternatives.filter(alt => alt && alt.medicinename && alt.medicinename.toLowerCase() !== item.matchedProduct?.medicinename?.toLowerCase());
            if (originalPackaging) {
              alts = alts.sort((a, b) => {
                const aPack = String(a.packaging || a.packaging_detail || '').toLowerCase();
                const bPack = String(b.packaging || b.packaging_detail || '').toLowerCase();
                const aMatch = aPack === originalPackaging ? 0 : 1;
                const bMatch = bPack === originalPackaging ? 0 : 1;
                return aMatch - bMatch;
              });
            }
            matchResult.alternatives = alts;
          }
          
          // CRITICAL FIX: Ensure originalData has productName field
          // Backend might return it as medicinename, ensure both exist for compatibility
          const originalData = item.originalData || {};
          if (!originalData.productName && originalData.medicinename) {
            originalData.productName = originalData.medicinename;
          }
          if (!originalData.medicinename && originalData.productName) {
            originalData.medicinename = originalData.productName;
          }
          
          // Log if productName is still missing after normalization
          if (!originalData.productName && !originalData.medicinename) {
            console.warn('[DATA-WARNING] Row missing both productName and medicinename:', item);
          }
          
          return {
            originalData: originalData,
            matchResult
          };
        });
        
        // Debug log to verify exact matches have no alternatives
        const exactWithAlts = transformedData.filter(p => 
          (p.matchResult.matchType === 'exact' || p.matchResult.confidence === 100) && 
          p.matchResult.alternatives && 
          p.matchResult.alternatives.length > 0
        );
        if (exactWithAlts.length > 0) {
          console.error(`[BUG] Found ${exactWithAlts.length} exact matches with alternatives (SHOULD BE 0):`, exactWithAlts);
        } else {
          console.log(`[SUCCESS] All exact matches have 0 alternatives ✓`);
        }
        
        // DEBUG: Verify productName normalization worked
        const missingProductName = transformedData.filter(p => !p.originalData?.productName);
        if (missingProductName.length > 0) {
          console.error(`[DATA-ERROR] ${missingProductName.length} items missing productName after normalization:`, 
            missingProductName.slice(0, 3).map(p => p.originalData)
          );
        } else {
          console.log(`[SUCCESS] All ${transformedData.length} items have productName ✓`);
        }
        
        // DEBUG: Log sample of unmatched products to verify data
        const unmatchedSample = transformedData.filter(p => 
          p.matchResult.matchType === 'unmatched' || p.matchResult.matchType === 'invalid'
        ).slice(0, 3);
        if (unmatchedSample.length > 0) {
          console.log('[UNMATCHED-SAMPLE] First 3 unmatched products originalData:');
          unmatchedSample.forEach((p, i) => {
            console.log(`  [${i + 1}]`, {
              productName: p.originalData.productName,
              medicinename: p.originalData.medicinename,
              manufacturer: p.originalData.manufacturer,
              packaging: p.originalData.packaging,
              mrp: p.originalData.mrp
            });
          });
        }
        
        const transformEnd = Date.now();
        console.log(`[FRONTEND] Transformed ${transformedData.length} results in ${transformEnd - transformStart}ms`);
        
        setMatchingProgress(95);
        setLoadingMessage('Preparing preview...');
        
        setMatchedProducts(transformedData);
        setShowPreview(true);
        setShowMappingDialog(false);
        setMatchingProgress(100);
        
        const matchedCount = transformedData.filter(p => 
          p.matchResult?.matchType === 'exact' || p.matchResult?.matchType === 'fuzzy'
        ).length;
        
        const totalTime = Date.now() - mapStart;
        console.log(`[FRONTEND] Total processing time: ${totalTime}ms`);
        
        toast.success(`Products matched: ${matchedCount} out of ${transformedData.length} (${totalTime}ms)`);
        
        // Auto-export validation report if there were skipped products due to validation errors
        if (skippedProductsReport && skippedProductsReport.length > 0) {
          console.log('[EXPORT] Auto-exporting validation report with skipped products');
          setTimeout(() => {
            exportValidationReport(successfulProductsReport, skippedProductsReport);
          }, 500);
        }
      } else {
        toast.error('Error matching products');
      }
    } catch (error) {
      console.error('[FRONTEND ERROR] Error matching products:', error);
      console.error('[FRONTEND ERROR] Error details:', {
        message: error.message,
        code: error.code,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        productCount: excelRawData?.length || 0
      });
      
      // Check if it's a timeout error (504 or network timeout)
      if (error.code === 'ECONNABORTED' || error.message?.includes('timeout') || 
          error.response?.status === 504 || error.response?.status === 502) {
        const productCount = excelRawData?.length || 0;
        
        // Different messages for small vs large datasets
        if (productCount <= 100) {
          toast.error(
            `⏱️ Backend Server Timeout: ${productCount} products should process quickly!\n\n` +
            `🔴 CRITICAL BACKEND ISSUE:\n` +
            `• Server is timing out even for small datasets\n` +
            `• This indicates a serious backend performance problem\n` +
            `• Check backend server logs immediately\n` +
            `• Verify database connection and server resources\n\n` +
            `💡 Contact your backend developer/admin urgently.`,
            { autoClose: 20000 }
          );
          console.error('[CRITICAL] Backend timing out for small dataset. Possible issues:');
          console.error('  1. Database connection pool exhausted');
          console.error('  2. Backend server CPU/RAM maxed out');
          console.error('  3. Database queries extremely slow (missing indexes)');
          console.error('  4. Backend server crashed/not responding');
          console.error('  5. Network issues between frontend and backend');
        } else {
          toast.error(
            `⏱️ Server Timeout: Processing ${productCount} products took too long.\n\n` +
            `💡 The system uses batch processing for large datasets (>1000).\n` +
            `For now, try splitting into smaller files or contact administrator.`,
            { autoClose: 15000 }
          );
        }
        console.error('[TIMEOUT] Backend server timeout. Product count:', productCount);
      } else if (error.response?.status === 500) {
        toast.error(
          `❌ Server Error: Backend failed to process the request.\n\n` +
          `Please check:\n` +
          `• Backend server logs for errors\n` +
          `• Database connection\n` +
          `• Data format consistency`,
          { autoClose: 10000 }
        );
      } else {
        toast.error('Error matching products to database. Please try again or contact support.');
      }
      
      setIsLoading(false);
    }
  };

  // Handle product data edit in preview
  const handleProductEdit = (index, field, value) => {
    const updated = [...matchedProducts];
    updated[index].originalData[field] = value;
    setMatchedProducts(updated);
  };

  // Handle alternative product selection
  const handleSelectAlternative = (index, alternative) => {
    const updated = [...matchedProducts];
    const selectedProduct = alternative.product || alternative;
    const selectedConfidence = alternative.confidence || 75;
    
    // Keep existing alternatives but mark this as selected
    const currentAlternatives = updated[index].matchResult?.alternatives || [];
    
    updated[index].matchResult = {
      ...updated[index].matchResult,
      matchType: selectedConfidence >= 80 ? 'fuzzy' : 'partial',
      confidence: selectedConfidence,
      product: selectedProduct,
      alternatives: currentAlternatives, // Preserve alternatives for further selection
      message: `Alternative selected by user (${selectedConfidence}% match)`
    };
    setMatchedProducts(updated);
    toast.success(`Selected: ${selectedProduct.medicinename} (${selectedConfidence}% confidence)`, {
      autoClose: 3000
    });
  };

  // Note: Unmatched products will be auto-created with validation flags
  // They can be reviewed and mapped to correct products later
  const handleMarkForReview = (index) => {
    const product = matchedProducts[index];
    toast.info(`"${product.originalData.productName}" will be added and flagged for validation`, { autoClose: 3000 });
  };

  // Submit unmapped products for admin approval
  const handleSubmitForApproval = async (unmappedProducts) => {
    // Posted in chunks. A 10k-row submission in a single request is several MB of
    // JSON and needs ~10k sequential inserts server side, which runs past the
    // proxy's body-size and read timeouts - the request died before the controller
    // could answer, so the client only ever saw a bodyless gateway error and
    // reported the generic "Error submitting products for approval". Chunking
    // mirrors what the match step already does for large uploads (same 500) and
    // keeps every request small and quick. Server-side insert behaviour, per-row
    // failure counting and the response shape are all untouched.
    const SUBMIT_CHUNK_SIZE = 500;

    try {
      setIsLoading(true);
      setLoadingMessage('Submitting products for admin approval...');

      // Validate unmapped products have packaging before submission.
      // Skipped rows are collected and reported in one toast at the end: warning
      // per row queued thousands of toasts on a 10k upload (ToastContainer has no
      // `limit`), freezing the tab before the first request was even sent.
      const skippedForPackaging = [];
      const preparedProducts = unmappedProducts
        .filter(p => {
          const hasPackaging = p.originalData?.packaging || p.originalData?.Packaging;
          if (!hasPackaging) {
            skippedForPackaging.push(
              p.originalData?.productName || p.originalData?.medicine_name || 'Unnamed product'
            );
          }
          return hasPackaging;
        })
        .map(p => {
          // Normalize expiry date before submission
          const rawExpiryDate = p.originalData?.expiryDate || p.originalData?.expiry_date || p.originalData?.expiry || '';
          const normalizedExpiryDate = normalizeExpiryDate(rawExpiryDate);

          return {
            medicine_name: p.originalData?.productName || p.originalData?.medicine_name,
            manufacturer: p.originalData?.manufacturer || '',
            strength: p.originalData?.strength || '',
            size: p.originalData?.size || '',
            packaging: p.originalData?.packaging || p.originalData?.Packaging || '',
            composition: p.originalData?.composition || '',
            form: p.originalData?.form || '',
            batch: p.originalData?.batch || '',
            expiry_date: normalizedExpiryDate,
            quantity: p.originalData?.quantity || '0',
            mrp: p.originalData?.mrp || '0',
            hsn_code: p.originalData?.hsn_code || '',
            description: p.originalData?.description || ''
          };
        });

      // Collapse repeats of the same lot before anything is posted. The server
      // applies this same rule (name + manufacturer + batch, later row wins), but
      // only ever saw one chunk at a time, so a lot appearing in two different
      // chunks reached it as two separate requests. Doing it here keeps the
      // semantics identical while letting the chunks below run concurrently: no
      // two in-flight requests can now carry the same lot and race each other.
      const identityKey = (p) =>
        [p.medicine_name, p.manufacturer, p.batch]
          .map(v => String(v == null ? '' : v).trim().replace(/\s+/g, ' ').toLowerCase())
          .join('||');

      const dedupedByKey = new Map();
      preparedProducts.forEach(p => dedupedByKey.set(identityKey(p), p));
      const productsToSubmit = Array.from(dedupedByKey.values());

      const duplicateCount = preparedProducts.length - productsToSubmit.length;
      if (duplicateCount > 0) {
        console.log(`[SUBMIT-APPROVAL] Collapsed ${duplicateCount} duplicate row(s) before submitting`);
      }

      if (skippedForPackaging.length > 0) {
        const sample = skippedForPackaging.slice(0, 3).join(', ');
        toast.warning(
          `${skippedForPackaging.length} product(s) skipped - Packaging is required for approval. ` +
          `e.g. ${sample}${skippedForPackaging.length > 3 ? ' and more' : ''}`,
          { autoClose: 8000 }
        );
      }

      if (productsToSubmit.length === 0) {
        toast.error('No products with Packaging field to submit for approval');
        setIsLoading(false);
        return;
      }

      const chunks = [];
      for (let i = 0; i < productsToSubmit.length; i += SUBMIT_CHUNK_SIZE) {
        chunks.push(productsToSubmit.slice(i, i + SUBMIT_CHUNK_SIZE));
      }

      if (chunks.length > 1) {
        console.log(`[SUBMIT-APPROVAL] Splitting ${productsToSubmit.length} products into ${chunks.length} batches of ${SUBMIT_CHUNK_SIZE}`);
        toast.info(
          `Submitting ${productsToSubmit.length} products in ${chunks.length} batches. Please keep this tab open.`,
          { autoClose: 6000 }
        );
      }

      let createdCount = 0;
      let failedCount = 0;
      // Rows whose request never reached the server at all, as opposed to rows the
      // server took in and rejected (failedCount). Both are "not stored", but only
      // these are worth re-uploading unchanged.
      let unreachedCount = 0;
      let lastChunkError = null;

      // Posted a few at a time rather than strictly one after another. Each request
      // costs about a second server side, nearly all of it waiting on the database,
      // so a 20-chunk upload spent most of its wall time idle. The match step above
      // already uses this same worker pool for the same reason. The payload was
      // de-duplicated above, so concurrent chunks never carry the same lot.
      const SUBMIT_CONCURRENCY = 4;
      let chunksDone = 0;
      let nextChunkIndex = 0;

      const runChunk = async (chunkIndex) => {
        const chunk = chunks[chunkIndex];
        const from = chunkIndex * SUBMIT_CHUNK_SIZE + 1;
        const to = from + chunk.length - 1;
        const startedAt = Date.now();

        try {
          const response = await RetailerUploadService.submitForApproval({
            retailerId,
            unmappedProducts: chunk
          });

          // Report what the server actually stored, not what we posted. This used to
          // announce success purely from productsToSubmit.length, so a submission the
          // backend only partly recorded still looked completely successful - which is
          // how dropped products went unnoticed until someone checked the admin panel.
          const submitResult = (response && response.data && response.data.data) || {};
          createdCount += Number.isFinite(Number(submitResult.created_count))
            ? Number(submitResult.created_count)
            : chunk.length;
          failedCount += Number(submitResult.failed_count) || 0;
          console.log(
            `[SUBMIT-APPROVAL] Batch ${chunkIndex + 1}/${chunks.length} (products ${from}-${to}) took ${Date.now() - startedAt}ms`
          );
        } catch (chunkErr) {
          // A batch that fails must not discard the batches after it - otherwise one
          // blip near the start throws away everything the retailer uploaded. Keep
          // going and report the true totals once at the end.
          unreachedCount += chunk.length;
          lastChunkError = chunkErr;
          console.error(
            `[SUBMIT-APPROVAL] Batch ${chunkIndex + 1}/${chunks.length} (products ${from}-${to}) failed:`,
            chunkErr
          );
        }

        // Chunks finish out of order, so report how many are done rather than
        // which one is in flight.
        chunksDone += 1;
        if (chunks.length > 1) {
          setLoadingMessage(
            `Submitting products: ${chunksDone} of ${chunks.length} batches done (${productsToSubmit.length} products)...`
          );
        }
      };

      const submitWorker = async () => {
        while (nextChunkIndex < chunks.length) {
          const chunkIndex = nextChunkIndex;
          nextChunkIndex += 1;
          await runChunk(chunkIndex);
        }
      };

      await Promise.all(
        Array.from({ length: Math.min(SUBMIT_CONCURRENCY, chunks.length) }, submitWorker)
      );

      const notStoredCount = failedCount + unreachedCount;

      // Nothing landed: keep the unmatched rows on screen so they can be retried,
      // and surface the server's own message the way the single-request path did.
      if (createdCount === 0) {
        toast.error(
          (lastChunkError && lastChunkError.response?.data?.message) ||
          'Error submitting products for approval'
        );
        return;
      }

      if (notStoredCount > 0) {
        toast.warning(
          `Submitted ${createdCount} of ${productsToSubmit.length} products for admin approval. ${notStoredCount} could not be saved — please re-upload those rows.`,
          { autoClose: 8000 }
        );
      } else {
        toast.success(`Successfully submitted ${createdCount} products for admin approval!`, {
          autoClose: 5000
        });
      }

      // Remove submitted products from display
      const remainingProducts = matchedProducts.filter(p =>
        p.matchResult?.matchType !== 'unmatched' &&
        p.matchResult?.matchType !== 'invalid'
      );
      setMatchedProducts(remainingProducts);

    } catch (error) {
      console.error('Error submitting products for approval:', error);
      toast.error(error.response?.data?.message || 'Error submitting products for approval');
    } finally {
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  // Helper function to export skipped products to Excel
  const exportSkippedProductsToExcel = (skippedProducts) => {
    try {
      if (!skippedProducts || skippedProducts.length === 0) {
        toast.warning('No skipped products to export');
        return;
      }

      // Format data for Excel export
      const excelData = skippedProducts.map(skipItem => ({
        'Row Number': skipItem.rowNumber || '',
        'Product Name': skipItem.productData?.medicinename || skipItem.productData?.name || '',
        'Manufacturer': skipItem.productData?.manufacturer || '',
        'Packaging': skipItem.productData?.packaging || '',
        'MRP': skipItem.productData?.mrp || '',
        'Batch': skipItem.productData?.batch || '',
        'Expiry Date': skipItem.productData?.expiry_date || '',
        'Skip Reason': skipItem.reason || 'Unknown reason'
      }));

      // Create worksheet from data
      const ws = XLSX.utils.json_to_sheet(excelData);
      
      // Set column widths for better readability
      ws['!cols'] = [
        { wch: 12 }, // Row Number
        { wch: 20 }, // Product Name
        { wch: 18 }, // Manufacturer
        { wch: 15 }, // Packaging
        { wch: 12 }, // MRP
        { wch: 12 }, // Batch
        { wch: 14 }, // Expiry Date
        { wch: 35 }  // Skip Reason
      ];

      // Create workbook and add sheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Skipped Products');

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `skipped_products_${timestamp}.xlsx`;

      // Trigger download
      XLSX.writeFile(wb, filename);

      toast.success(`Exported ${skippedProducts.length} skipped products to ${filename}`, { autoClose: 4000 });
      console.log(`[EXCEL EXPORT] Exported ${skippedProducts.length} skipped products`);
    } catch (error) {
      console.error('Error exporting skipped products:', error);
      toast.error('Error exporting skipped products to Excel');
    }
  };

  // Helper function to export validation report (2 sheets: successful + skipped)
  const exportValidationReport = (successfulProducts, skippedProducts) => {
    try {
      if (successfulProducts?.length === 0 && skippedProducts?.length === 0) {
        toast.warning('No products to export');
        return;
      }

      // Create workbook with 2 sheets
      const wb = XLSX.utils.book_new();

      // SHEET 1: Successful Products
      if (successfulProducts && successfulProducts.length > 0) {
        const successData = successfulProducts.map((product, index) => ({
          'Row#': index + 1,
          'Product Name': product.medicinename || '',
          'Manufacturer': product.manufacturer || '',
          'Packaging': product.packaging || '',
          'MRP': product.mrp || '',
          'Batch': product.batch || '',
          'Quantity': product.quantity || '',
          'Expiry Date': product.expiry || '',
          'Status': '✓ SUCCESSFUL'
        }));

        const ws1 = XLSX.utils.json_to_sheet(successData);
        ws1['!cols'] = [
          { wch: 8 },   // Row#
          { wch: 25 },  // Product Name
          { wch: 20 },  // Manufacturer
          { wch: 15 },  // Packaging
          { wch: 12 },  // MRP
          { wch: 12 },  // Batch
          { wch: 12 },  // Quantity
          { wch: 15 },  // Expiry Date
          { wch: 15 }   // Status
        ];
        XLSX.utils.book_append_sheet(wb, ws1, 'Successful');
      }

      // SHEET 2: Skipped/Failed Products
      if (skippedProducts && skippedProducts.length > 0) {
        const skippedData = skippedProducts.map((skipItem, index) => ({
          'Row#': skipItem.rowNumber || index + 1,
          'Product Name': skipItem.productData?.medicinename || '',
          'Manufacturer': skipItem.productData?.manufacturer || '',
          'Packaging': skipItem.productData?.packaging || '(missing)',
          'MRP': skipItem.productData?.mrp || '(missing)',
          'Batch': skipItem.productData?.batch || '',
          'Status': '❌ SKIPPED',
          'Reason': skipItem.reason || 'Missing required fields'
        }));

        const ws2 = XLSX.utils.json_to_sheet(skippedData);
        ws2['!cols'] = [
          { wch: 8 },   // Row#
          { wch: 25 },  // Product Name
          { wch: 20 },  // Manufacturer
          { wch: 15 },  // Packaging
          { wch: 12 },  // MRP
          { wch: 12 },  // Batch
          { wch: 15 },  // Status
          { wch: 40 }   // Reason
        ];
        XLSX.utils.book_append_sheet(wb, ws2, 'Skipped');
      }

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `upload_report_${timestamp}.xlsx`;

      // Trigger download
      XLSX.writeFile(wb, filename);

      const successCount = successfulProducts?.length || 0;
      const skippedCount = skippedProducts?.length || 0;
      
      toast.success(
        `📊 Report exported: ${successCount} successful + ${skippedCount} skipped rows → ${filename}`,
        { autoClose: 5000 }
      );
      console.log(`[VALIDATION REPORT] Exported ${successCount} successful and ${skippedCount} skipped products`);
    } catch (error) {
      console.error('Error exporting validation report:', error);
      toast.error('Error exporting validation report to Excel');
    }
  };

  // Final upload to stock - ONLY matched products (confidence >= 80%)
  const handleFinalUpload = async (tabName = 'all', tabProducts = null) => {
    try {
      // Block upload if trying to upload unmapped tab
      if (tabName === 'unmatched') {
        toast.error('Cannot upload unmapped products. Please export to Excel instead.');
        return;
      }
      
      setIsLoading(true);
      setLoadingMessage(`Uploading ${tabName === 'all' ? 'all' : tabName} products...`);
      setUploadProgress(0);

      // Use tab products if provided, otherwise use all matched products
      const productsToProcess = tabProducts || matchedProducts;
      
      // FILTER: Only include matched products (exclude unmapped) and validate packaging
      const matchedOnly = productsToProcess.filter(p => {
        const matchType = p.matchResult?.matchType;
        const confidence = p.matchResult?.confidence || 0;
        const hasPackaging = p.originalData?.packaging || p.originalData?.Packaging;
        
        const isMatched = matchType !== 'unmatched' && matchType !== 'invalid' && 
                         (matchType === 'exact' || matchType === 'normalized' || matchType === 'direct' || confidence >= 80);
        
        if (isMatched && !hasPackaging) {
          console.warn(`[UPLOAD] Product missing packaging:`, p);
        }
        
        return isMatched;
      });
      
      if (matchedOnly.length === 0) {
        toast.error('No matched products to upload. All products are unmapped.');
        setIsLoading(false);
        return;
      }
      
      if (matchedOnly.length < productsToProcess.length) {
        const excludedCount = productsToProcess.length - matchedOnly.length;
        toast.warning(`${excludedCount} unmapped products excluded from upload. Export them to Excel instead.`, { autoClose: 5000 });
      }

      // Prepare ONLY matched products for upload
      const productsToUpload = matchedOnly.map(p => {
        const isMatched = p.matchResult?.product?.id || p.matchResult?.product?.medicineid;
        const isUnmatched = p.matchResult?.matchType === 'unmatched' || 
                           p.matchResult?.matchType === 'invalid';
        
        // Normalize expiry date before upload
        const rawExpiryDate = p.originalData.expiry || p.originalData.expiryDate || p.originalData.expiry_date || '';
        const normalizedExpiryDate = normalizeExpiryDate(rawExpiryDate);
        
        return {
          medicine_id: isMatched ? (p.matchResult.product.id || p.matchResult.product.medicineid) : null,
          batch: p.originalData.batch || '',
          quantity: p.originalData.quantity || 0,
          expiry_date: normalizedExpiryDate,
          mrp: p.originalData.mrp || 0,
          discount: p.originalData.discount || '0',
          vat: p.originalData.vat || '0',
          manufacturer: p.originalData.manufacturer || '',
          CGST: '0',
          SGST: '0',
          IGST: '0',
          commission: '0',
          // Flags for unmatched products
          willAutoCreate: isUnmatched,
          matchType: p.matchResult?.matchType,
          originalData: {
            productName: p.originalData.productName,
            medicinename: p.originalData.productName,
            manufacturer: p.originalData.manufacturer || '', // OPTIONAL
            strength: p.originalData.strength || '', // OPTIONAL (from packing)
            form: p.originalData.form || '',
            packaging: p.originalData.packaging || '',
            mrp: p.originalData.mrp || 0
          }
        };
      });

      if (productsToUpload.length === 0) {
        toast.error('No products to upload');
        setIsLoading(false);
        return;
      }
      
      console.log(`[FRONTEND] Uploading ${productsToUpload.length} matched products (${tabName})`);

      setUploadProgress(50);

      const response = await RetailerUploadService.uploadMappedStock(retailerId, productsToUpload);

      setUploadProgress(100);

      if (response.data && !response.data.error) {
        const results = response.data.data;
        const summary = results.summary;
        
        // Export skipped products to Excel if any exist
        if (response.data.data.skippedProducts && response.data.data.skippedProducts.length > 0) {
          exportSkippedProductsToExcel(response.data.data.skippedProducts);
        }
        
        let message = `Successfully uploaded ${summary.matchedUploaded || summary.stocksCreated || productsToUpload.length} matched products to stock`;
        
        if (summary.unmappedExcluded > 0) {
          message += `. ${summary.unmappedExcluded} unmapped products excluded - export them to Excel.`;
        }
        
        if (response.data.data.skippedProducts && response.data.data.skippedProducts.length > 0) {
          const skippedCount = response.data.data.skippedProducts.length;
          message += ` ${skippedCount} products were skipped (see exported report).`;
        }
        
        toast.success(message, { autoClose: 5000 });
        
        // Export validation report showing both successful and skipped products
        // This includes products skipped due to missing required field values during mapping
        if (skippedProductsReport && skippedProductsReport.length > 0) {
          console.log('[EXPORT] Calling exportValidationReport with:', {
            successfulCount: successfulProductsReport.length,
            skippedCount: skippedProductsReport.length
          });
          setTimeout(() => {
            exportValidationReport(successfulProductsReport, skippedProductsReport);
          }, 1000); // Slight delay to let upload complete first
        }
        
        if (summary.errors > 0) {
          toast.error(`${summary.errors} products had errors. Check console for details.`);
          console.error('Upload errors:', results.errors);
        }

        // Remove uploaded products from the list if tab-wise upload
        if (tabProducts) {
          const tabNameSafe = tabName || 'unknown';

          // Compute counts per tab before removal (for debugging/validation)
          const countByTab = (items) => {
            const exact = items.filter(p => p.matchResult?.matchType === 'exact').length;
            const needsReview = items.filter(p =>
              ['normalized', 'fuzzy', 'partial', 'internal_search'].includes(p.matchResult?.matchType)
            ).length;
            const unmatched = items.filter(p =>
              ['unmatched', 'invalid'].includes(p.matchResult?.matchType)
            ).length;
            return { exact, needsReview, unmatched, total: items.length };
          };

          const beforeCounts = countByTab(matchedProducts);

          // Only remove products that were actually uploaded (matchedOnly),
          // so products excluded from upload (e.g., due to missing required fields)
          // remain in the UI for correction.
          const uploadedSet = new Set(matchedOnly);
          const remainingProducts = matchedProducts.filter(p => !uploadedSet.has(p));

          const afterCounts = countByTab(remainingProducts);
          console.debug('[UPLOAD] Tab upload:', tabNameSafe, {
            tabProducts: tabProducts.length,
            uploaded: matchedOnly.length,
            before: beforeCounts,
            after: afterCounts
          });

          setMatchedProducts(remainingProducts);

          // If all products uploaded, leave the screen ready for the next
          // file. In the pharmacy portal that means the stock page; in the
          // admin panel there is no such page, so the screen just clears and
          // keeps the pharmacy selected above it.
          if (remainingProducts.length === 0) {
            setTimeout(() => {
              if (embedded) {
                clearUploadedFile();
                return;
              }
              window.location.href = './Retailerstock';
            }, 2000);
          } else {
            toast.info(`${remainingProducts.length} products remaining in other tabs`);
          }
        } else {
          // Full upload - back to the stock page, or a cleared screen when the
          // admin panel is driving the upload.
          setTimeout(() => {
            if (embedded) {
              clearUploadedFile();
              return;
            }
            window.location.href = './Retailerstock';
          }, 3000);
        }
      } else {
        toast.error('Error uploading stock');
      }
    } catch (error) {
      console.error('Error uploading stock:', error);
      toast.error('Error uploading stock data');
    } finally {
      setIsLoading(false);
      setLoadingMessage('');
      setUploadProgress(0);
    }
  };
  //  Puts the screen back to "no file chosen" without touching the chosen
  //  pharmacy, so another file can be uploaded straight away.
  const clearUploadedFile = () => {
    setColumns([]);
    setData([]);
    setbutton("upload_stock_btn collapse-hide");
    setExcelHeaders([]);
    setExcelRawData([]);
    excelDataRef.current = { headers: [], rows: [] };
    setMappedProducts([]);
    setMatchedProducts([]);
    setShowPreview(false);
    setUseAdvancedMode(false);
    setSelectedFileName('');
    setSkippedProductsReport([]);
    setSuccessfulProductsReport([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  //  For navigation. Embedded in the admin panel there is no pharmacy stock
  //  page to go back to, so the screen just resets instead.
  const back = (e) => {
    if (embedded) {
      clearUploadedFile();
      return;
    }
    window.location.href = "./Retailerstock";
  };
  //  For checking mapping/validation
  const handleCheckMapping = () => {
    if (excelHeaders.length === 0 || excelRawData.length === 0) {
      toast.warning('Please upload a file first to check the mapping');
      return;
    }
    console.log('[VALIDATION] Opening mapping dialog for verification');
    setShowMappingDialog(true);
  };
  //  For handleChange
  const handleChange = (event) => {
    let index = event.target.id.split(",");
    let key = index[0];
    let column = index[1];

    data[key][column] = event.target.value;
  };
  //  For uploadData
  const uploadData = () => {
    if (!retailerId) {
      toast.error("Select a pharmacy before uploading stock");
      return;
    }

    // Packaging is now optional - removed validation

    for (let i = 0; i < data.length; i++) {
      excelData.push({
        retailer_id: retailerId,
        product_id: data[i]["ProductId"],
        medicine_id: data[i]["MedicineId"],
        packaging: data[i]["Packaging"],
        batch: data[i]["Batch"],
        expiry_date: data[i]["Expirydate"],
        quantity: data[i]["Quantity"],
        mrp: data[i]["MRP"],
        discount: data[i]["Discount"],
        vat: data[i]["VAT"],
        commission: "0",
        CGST: "0",
        SGST: "0",
        IGST: "0",
      });
    }

    Httpconfig.httptokenpost(
      Constant.siteurl + "api/OM/retailerProduct/uploadProductStockExcelData",
      { excelData }
    )
      .then((response) => {
        if ((response.data.status = 200)) {
          toast.success(response.message);
          if (!embedded) {
            setTimeout(() => (window.location.href = "./Retailerstock"), 1000);
          }
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  //  Everything from the "Upload File" heading down. It is the same screen in
  //  both places; only the frame around it differs, so it is built once here
  //  and placed by whichever wrapper is returned below.
  const uploadScreen = (
    <>
              <div class="stock_top_section">
                {!embedded && (
                  <div>
                    <a onClick={back}>
                      <img src="../images/retailer/add_medicine_arrow.svg" />{" "}
                      Back to Add New Medicine
                    </a>
                  </div>
                )}
                <h3>Upload File</h3>
              </div>

              {/* Auto-detection Info */}
              <div className="mb-3">
                <Alert variant="info" style={{ padding: '12px 15px', fontSize: '14px' }}>
                  <strong>🔍 Smart Upload:</strong> Upload any Excel file with your own column headers.
                  <ul style={{ marginBottom: 0, marginTop: '8px', paddingLeft: '20px' }}>
                    <li>✅ <strong>Excel headers can be anything</strong> (Product, Drug Name, Item, Price, etc.)</li>
                    <li>📋 <strong>Column Mapping Dialog will open</strong> - you MUST map required fields</li>
                    <li style={{color: '#d32f2f', marginTop: '8px', fontWeight: 'bold'}}>⚠️ MANDATORY in Mapping: MedicineName, Packaging, MRP must be mapped to your Excel columns</li>
                    <li>All other fields (Manufacturer, Batch, Quantity, etc.) are optional</li>
                  </ul>
                </Alert>
                {savedMapping && (
                  <Alert variant="success" className="mt-2" style={{ padding: '10px 15px', fontSize: '13px' }}>
                    <i className="bi bi-check-circle"></i> <strong>Saved Mapping Available:</strong> You will be asked to verify your column mapping on every upload.
                  </Alert>
                )}
              </div>

              <div className="mb-3" style={{ marginBottom: "15px" }}>
                <label
                  htmlFor="stock_upload_file"
                  style={{ display: "block", fontWeight: "bold", marginBottom: "6px" }}
                >
                  Choose Excel / CSV file
                </label>
                {/* Sized inline, because several portal stylesheets hide file
                    inputs behind their own upload buttons; this one has no such
                    button and must stay on screen wherever it is rendered. */}
                <input
                  id="stock_upload_file"
                  type="file"
                  accept=".csv,.xlsx,.xls"
                  onChange={handleFileUpload}
                  className="form-control"
                  ref={fileInputRef}
                  disabled={isLoading}
                  style={{
                    display: "block",
                    visibility: "visible",
                    opacity: 1,
                    width: "100%",
                    maxWidth: "520px",
                    height: "auto",
                    padding: "8px",
                    border: "1px solid #c0c0c0",
                    borderRadius: "4px",
                    background: "#ffffff",
                    color: "#3b3b3b",
                  }}
                />
                {selectedFileName && (
                  <small className="text-muted">
                    <i className="bi bi-file-earmark-excel"></i> Selected: {selectedFileName}
                  </small>
                )}
              </div>

              {/* Check Mapping Button */}
              {selectedFileName && (
                <div className="mb-3">
                  <Button 
                    variant="info" 
                    size="sm"
                    onClick={handleCheckMapping}
                    disabled={isLoading || excelHeaders.length === 0}
                    className="me-2"
                  >
                    ✓ Check Mapping
                  </Button>
                  <small className="text-muted ml-2">
                    Click to verify your column mapping before uploading
                  </small>
                </div>
              )}

              {/* Loading indicator */}
              {isLoading && (
                <Alert variant="info">
                  <Spinner animation="border" size="sm" className="me-2" />
                  {loadingMessage}
                  {(uploadProgress > 0 || matchingProgress > 0) && (
                    <ProgressBar 
                      now={uploadProgress > 0 ? uploadProgress : matchingProgress} 
                      label={`${uploadProgress > 0 ? uploadProgress : matchingProgress}%`} 
                      className="mt-2"
                      animated
                      striped
                    />
                  )}
                </Alert>
              )}

              {/* Advanced Mode: Product Match Preview */}
              {useAdvancedMode && showPreview && !isLoading && (
                <div className="mt-4">
                  <h4>Product Match Preview</h4>
                  <ProductMatchPreview
                    products={matchedProducts}
                    onEdit={handleProductEdit}
                    onValidate={handleMarkForReview}
                    onSelectAlternative={handleSelectAlternative}
                    onUploadTab={handleFinalUpload}
                    onSubmitForApproval={handleSubmitForApproval}
                    retailerId={retailerId}
                  />
                  {/* Removed global upload button - use tab-wise buttons instead */}
                </div>
              )}

              {/* Legacy Mode: Original table view */}
              {!useAdvancedMode && data.length > 0 && (
                <div
                  class="tab-pane fade"
                  id="running_home"
                  role="tabpanel"
                  aria-labelledby="running_home-tab"
                >
                  <div class="">
                    <div class="stock_body">
                      <div class="col-md-12 no_padding">
                        <div class="table-responsive">
                          <table border="1">
                            <thead>
                              {data.length > 0
                                ? data.map((finalLoadedData, num) => (
                                    <React.Fragment key={num}>
                                      {num == 0 ? (
                                        <tr>
                                          <th>S.No</th>
                                          <th>Medicine Id</th>
                                          <th>Product Id</th>
                                          <th>Medicine Name</th>
                                          <th>Manufacturer</th>
                                          <th>Packaging</th>
                                          <th>Batch</th>
                                          <th>Quantity</th>
                                          <th>Expire Date</th>
                                          <th>Discount</th>
                                          <th>MRP</th>
                                          <th>GST</th>
                                        </tr>
                                      ) : (
                                        ""
                                      )}
                                      <tr>
                                        <td>{num + 1}</td>
                                        <td>{finalLoadedData.MedicineId}</td>
                                        <td>{finalLoadedData.productId}</td>
                                        <td>{finalLoadedData.MedicineName}</td>
                                        <td>{finalLoadedData.Manufacturer}</td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp"
                                            id={num + ",Packaging"}
                                            defaultValue={finalLoadedData.Packaging}
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp"
                                            id={num + ",Batch"}
                                            defaultValue={finalLoadedData.Batch}
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp"
                                            id={num + ",Quantity"}
                                            defaultValue={
                                              finalLoadedData.Quantity
                                            }
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp date_inp"
                                            id={num + ",Expirydate"}
                                            defaultValue={
                                              finalLoadedData.Expirydate
                                            }
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp"
                                            id={num + ",Discount"}
                                            defaultValue={
                                              finalLoadedData.Discount
                                            }
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp"
                                            id={num + ",MRP"}
                                            defaultValue={finalLoadedData.MRP}
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            class="form-control stock_inp"
                                            id={num + ",VAT"}
                                            defaultValue={finalLoadedData.GST}
                                            onKeyUp={handleChange}
                                          />
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  ))
                                : ""}
                            </thead>
                            <tbody></tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bottom_btns">
                    <div class={showbutton}>
                      <a href="#">
                        <button type="button" onClick={uploadData}>
                          Add to stock
                        </button>
                      </a>
                    </div>
                    &nbsp;
                    <div class="upload_stock_btn" onClick={back}>
                      <a href="#">
                        <button type="button">Cancel</button>
                      </a>
                    </div>
                  </div>
                </div>
              )}
    </>
  );

  //  Admin panel (Operations > Stock Upload): the pharmacy comes from the
  //  dropdown on that screen, so this renders as a plain block inside the
  //  admin page. The pharmacy portal's own frame - <main id="main">,
  //  #Pharmacy_dashboard, .stock_update - is deliberately left out: its 7%
  //  margins, 700px min-height and portal-scoped rules push this screen out of
  //  the admin layout, which is what made the file picker impossible to find.
  if (embedded) {
    return (
      <div id="admin_stock_upload" style={{ padding: "0px 15px 30px 15px" }}>
        {uploadScreen}

        {/* Column Mapping Dialog */}
        <ColumnMappingDialog
          show={showMappingDialog}
          onClose={() => setShowMappingDialog(false)}
          excelHeaders={excelHeaders}
          excelRawData={excelRawData}
          savedMapping={savedMapping}
          onSave={handleSaveMapping}
        />
        <ToastContainer />
      </div>
    );
  }

  //  Pharmacy portal: the screen inside the retailer chrome, unchanged.
  return (
    <main id="main">
      <section id="Pharmacy_dashboard">
        <div class="row">
          <RetailerHeader />
          <RetailerSideMenu />
          <div class="stock_update">
            <div class="container">{uploadScreen}</div>
          </div>

          {/* Column Mapping Dialog */}
          <ColumnMappingDialog
            show={showMappingDialog}
            onClose={() => setShowMappingDialog(false)}
            excelHeaders={excelHeaders}
            excelRawData={excelRawData}
            savedMapping={savedMapping}
            onSave={handleSaveMapping}
          />
        </div>
        <ToastContainer />
        <PatientFooter />
      </section>
    </main>
  );
}

export default Retaileruploadstock;
